import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ForgetPassword.css';
import BackButton from './BackButton';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleForgetPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://backend.aubattle.com/api/auth/forget-password', { email });
      setMessage(response.data.message);
      setError('');
      
      // Redirect to Reset Password page after 2 seconds
      setTimeout(() => navigate('/reset-password'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong!');
      setMessage('');
    }
  };

  return (
   <div className="forget-password-container">
    <BackButton/>
  <h2>Forget Password</h2>
  <form onSubmit={handleForgetPassword}>
    <input
      type="email"
      placeholder="Enter your email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
    />
    <button type="submit">Send Reset Link</button>
  </form>
  {message && <p className="success">{message}</p>}
  {error && <p className="error">{error}</p>}
</div>

  );
};

export default ForgetPassword;
